import { render, staticRenderFns } from "./BuscadorPagoPage.vue?vue&type=template&id=4919cca7"
import script from "./BuscadorPagoPage.js?vue&type=script&lang=js&external"
export * from "./BuscadorPagoPage.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports